<template>
  <div>
    <div v-if="isUnableToSendSingleAppointmentConfirmation">
      <v-alert class="red lighten-5 mt-2 mb-6">
        <p class="body-2 red--text mb-2">
          {{ $t('appointment.confirmAppointment.sendEmailModal.unableToSendEmail') }}
        </p>
        <v-chip class="mr-1 mb-1 red" x-small>
          <span class="white--text">
            {{ appointmentCode }}
          </span>
        </v-chip>
        <p class="caption red--text mt-2">
          {{ $t('appointment.confirmAppointment.sendEmailModal.unableToSendEmailTip') }}
        </p>
      </v-alert>
    </div>
    <div v-else>
      <p class="body-2 mb-2">
        {{ $t('appointment.confirmAppointment.sendEmailModal.sendEmailMessageSingle')}}
      </p>
      <v-chip class="mr-1 mb-1 orange" x-small>
        <span class="white--text">
          {{ appointmentCode }}
        </span>
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalBulkSendConfirmationEmailSingleAppointment',

  props: {
    appointmentAbleToSendConfirmation: {
      type: Array,
      required: false,
      default: () => [],
    },

    appointmentUnableToSendConfirmation: {
      type: Array,
      required: false,
      default: () => [],
    },

    isUnableToSendSingleAppointmentConfirmation: {
      type: Boolean,
      required: false,
    },
  },

  watch: {
    appointmentUnableToSendConfirmation(value) {
      if (value.length <= 0) return
      this.appointmentCode = value[0]?.code
    },

    appointmentUnableToSendConfirmation(value) {
      if (value.length <= 0) return
      this.appointmentCode = value[0]?.code
    },
  },

  computed: {
    appointmentCode: {
      get() {
        return this.appointmentUnableToSendConfirmation.length > 0
          ? this.appointmentUnableToSendConfirmation[0]?.code
          : this.appointmentAbleToSendConfirmation[0]?.code
      },
      set(value) {
        return value
      },
    }
  },
}
</script>
